module.exports = __webpack_public_path__ + "assets/total_lead_scheduled.fff82ad4.svg";